/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, {useEffect, useState, useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {sortCountriesByLocale} from '../../../utils/countryNames'
import {connect, useDispatch} from 'react-redux'
import {useHistory} from 'react-router'
import swal from 'sweetalert'

import * as auth from '../auth/redux/AuthRedux'
import {SSO_ENABLED} from '../../../setup/keycloak/authConfig'

import {PaymentMethod, PaymentMethodSettings} from '~/lib/utils'
// Provider routing now handled server-side
import {getCountryDisplayName} from '../../../utils/countryUtils'
import {getInvoicePrice, isMasteryProduct} from '../../../lib/masteryDiscount'
import {KTSVG} from '../../../_metronic/helpers'
import {PaymentMethodSelector} from '../shared/PaymentMethodSelector'
import {
  BACKEND_API_URL,
  BACKEND_API_V2,
  DEFAULTTOKEN,
  removeAllSession,
} from '../../../config/config'
import {AppState} from '../../../setup/redux/Store'
import {WebshopState} from '../personalorder/components/newComponents/types'
import CouponComponent, {CouponObject} from '../webshop/components/CouponComponent'
import '../webshop/webshop.css'
import {isSafariBrowser} from '~/config/utils'
import {computeBillingAddressSelection} from './billingAddressSelection'
import {buildSignUpBody} from './signUpBody'
import {checkoutVatSummary} from '../../../utils/checkoutVatSummary'
import {toCents, fromCents} from '../../../utils/vatMoney'
import {getVatEstimate, VatEstimate} from '../../../utils/vatApi'
import {resolveBillingCountryId, resolveDisplayVatRate} from './billingCountry'

interface Props {
  setViewStatus: React.Dispatch<React.SetStateAction<number>>
  state: WebshopState
  // Redux props (from mapStateToProps)
  shoppingCart: Array<any>
  curUserInfo: any
  sponserUserName: string
  sponsorId: number
  sponsorFirstName: string
  sponsorSecondName: string
  globalMasteryDiscount: number
}

function PaymentInfo({
  setViewStatus,
  shoppingCart,
  curUserInfo,
  sponserUserName,
  sponsorId,
  sponsorFirstName,
  sponsorSecondName,
  state,
  globalMasteryDiscount = 0,
}: Props) {
  const history = useHistory()
  const dispatch = useDispatch()
  const {t, i18n} = useTranslation()
  const [backStyle, setBackStyle] = useState('')
  const [curEuroRate, setCurEuroRate] = useState(1.024)
  const [addAddoressStyle, setAddAddressStyle] = useState('modal')
  const [curBillingAddress, setCurBillingAddress] = useState<Array<any>>([])
  const [curShoppingCart, setCurShoppingCart] = useState<Array<any>>([])
  const [totalPrice, setTotalPrice] = useState(0)
  const [curUserToBilling, setCurUserToBilling] = useState(true)
  const [containBilling, setContainBilling] = useState(false)
  const [curTrustStatus, setCurTrustStatus] = useState(false)
  const [curCountryCode, setCurCountryCode] = useState('')
  const [curCreateSubLoading, setCurCreateSubLoading] = useState(false)
  // VAT estimate for the SELECTED BILLING COUNTRY (Task 4 fix round 1) — distinct from
  // state.vatEstimate, which is the shop-entry IP-estimated lookup fetched once before the member
  // ever picks a country. null until a billing country is resolved and its estimate fetched, or
  // on any fetch failure (getVatEstimate never throws; see resolveDisplayVatRate's 0 fallback).
  const [curBillingVatEstimate, setCurBillingVatEstimate] = useState<VatEstimate | null>(null)

  // Legal Terms Flags
  const [curTermsStatus, setCurTermsStatus] = useState(false)
  const [curDisclaimerStatus, setCurDisclaimerStatus] = useState(false)
  const [curEmailStatus, setCurEmailStatus] = useState(false)

  // Coupon
  const [coupons, setCoupons] = useState<CouponObject[]>([])
  const [buyAsCoupon, setBuyAsCoupon] = useState<boolean>(false)

  // Personal Information
  const [curCompanyname, setCurCompanyname] = useState('')
  const [curFirstName, setCurFirstName] = useState('')
  const [curLastName, setCurLastName] = useState('')
  const [curStreet, setCurStreet] = useState('')
  const [curSuite, setCurSuite] = useState('')
  const [curZipcode, setCurZipcode] = useState('')
  const [curCity, setCurCity] = useState('')
  const [curCountry, setCurCountry] = useState('')
  const [curCountryId, setCurCountryId] = useState(0)

  // Payment methods
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>()

  // View States about Payment methods
  const [paymentMethodSettings, setPaymentMethodSettings] = useState<PaymentMethodSettings>({
    cardinity: false,
    airwallex_eps: false,
    airwallex_giropay: false,
    airwallex_applepay: false,
    airwallex_googlepay: false,
    airwallex_cc: false,
    advcash: false,
    bpay: false,
    micropayment_prepay: false,
    micropayment_sofort: false,
    reap_cc: false,
    coinbase: false,
    skrill_rapid: false,
    skrill_cc: false,
    skrill_neteller: false,
    skrill: false,
  })

  // Get Countries Information
  const [curCountries, setCurCountries] = useState<Array<any>>([])
  const [unCheckedCountry, setUnCheckedCountry] = useState('')
  // Active countries localized to the UI language and sorted in its order (see personinfo).
  const localizedCountries = useMemo(
    () => sortCountriesByLocale(curCountries.filter((c) => c.status === 1), i18n.language),
    [curCountries, i18n.language]
  )
  const [unCheckedCountryId, setUnCheckedCountryId] = useState(-1)

  const [hasBasicPlanGift, setHasBasicPlanGift] = useState(false)

  // Helper function to calculate the correct price for invoice total
  const calculateInvoicePrice = (item: any) => {
    const price = getInvoicePrice(item)
    const result = price ? Math.round(price * 100) / 100 : 0 // Round to 2 decimal places, fallback to 0

    console.log('Shopping Cart PaymentInfo - calculateInvoicePrice:', {
      itemName: item.card_name,
      invoice_price: item.invoice_price,
      itemDiscount: item.discount,
      itemPrice: item.price,
      finalPrice: price,
      result,
    })

    return result
  }

  let shoppingCartWithCoupons = shoppingCart

  useEffect(() => {
    console.log('Shopping Cart PaymentInfo - useEffect debug:', {
      globalMasteryDiscount,
      shoppingCartLength: shoppingCart.length,
      shoppingCart: shoppingCart,
    })

    // Debug each item in the cart
    shoppingCart.forEach((item, index) => {
      console.log(`Shopping Cart PaymentInfo - Cart item ${index}:`, {
        itemName: item.card_name,
        isMastery: isMasteryProduct(item),
        is_mastery: item.is_mastery,
        price: item.price,
        discount: item.discount,
        discount_flag: item.discount_flag,
      })
    })

    setHasBasicPlanGift(false)

    let tempTotal = 0
    let tempShoppingCart = []

    coupons.forEach((coupon) => {
      const {plan_id, coupon: couponCode} = coupon
      let plan = state.addons.find((item) => item.id === plan_id)
      if (plan) {
        !shoppingCartWithCoupons[1].some((p: {id: any}) => p.id === plan.id) &&
          shoppingCartWithCoupons[1].push(Object.assign({}, plan))
        return
      }
      plan = state.addons_addons.find((item) => item.id === plan_id)
      if (plan) {
        !shoppingCartWithCoupons[2].some((p: {id: any}) => p.id === plan.id) &&
          shoppingCartWithCoupons[2].push(Object.assign({}, plan))
        return
      }
      plan = state.basePlans.find((item) => item.id === plan_id)
      if (plan) {
        setHasBasicPlanGift(true)
        shoppingCartWithCoupons[0] = Object.assign({}, plan)
        return
      }
      plan = state.affiliatePlans.find((item) => item.id === plan_id)
      if (plan) {
        shoppingCartWithCoupons[3] = Object.assign({}, plan)
        return
      }
    })

    for (let i = 0; i < shoppingCartWithCoupons.length; i++) {
      if (i === 1 || i === 2) {
        for (let j = 0; j < shoppingCartWithCoupons[i].length; j++) {
          if (Object.keys(shoppingCartWithCoupons[i][j]).length > 0) {
            let tempData: any = {}
            const is_coupon = coupons.find(
              (coupon) => coupon.plan_id === shoppingCartWithCoupons[i][j].id
            )
            tempData.id = shoppingCartWithCoupons[i][j].id
            tempData.product_image = shoppingCartWithCoupons[i][j].product_image
            tempData.status = shoppingCartWithCoupons[i][j].status
            tempData.scheduled_time = shoppingCartWithCoupons[i][j].scheduled_time
            tempData.card_name =
              shoppingCartWithCoupons[i][j].card_name + (is_coupon ? ` ${is_coupon.coupon}` : '')
            tempData.card_description = shoppingCartWithCoupons[i][j].card_description
            tempData.long_description = shoppingCartWithCoupons[i][j].long_description
            tempData.checked_attributes = shoppingCartWithCoupons[i][j].checked_attributes
            tempData.unchecked_attributes = shoppingCartWithCoupons[i][j].unchecked_attributes
            tempData.price = shoppingCartWithCoupons[i][j].price
            tempData.discount_flag = is_coupon ? true : shoppingCartWithCoupons[i][j].discount_flag
            tempData.discount = is_coupon ? 0 : shoppingCartWithCoupons[i][j].discount
            tempData.type = shoppingCartWithCoupons[i][j].type
            tempData.subscription_length =
              shoppingCartWithCoupons[i][j].subscription_length.length || 0
            tempData.quantity = shoppingCartWithCoupons[i][j].quantity
            tempData.quantity_ignore_flag = shoppingCartWithCoupons[i][j].quantity_ignore_flag
            tempData.product_volume = shoppingCartWithCoupons[i][j].product_volume
            tempData.rank_volume = shoppingCartWithCoupons[i][j].rank_volume
            tempData.hpp_units = shoppingCartWithCoupons[i][j].hpp_units
            tempData.hpp_coupons = shoppingCartWithCoupons[i][j].hpp_coupons
            tempData.products = shoppingCartWithCoupons[i][j].products
            tempData.ea_flag = shoppingCartWithCoupons[i][j].ea_flag
            tempData.ea_license_id = shoppingCartWithCoupons[i][j].ea_license_id
            tempData.vps_image_name = shoppingCartWithCoupons[i][j].vps_image_name
            tempData.selLengthIndex = shoppingCartWithCoupons[i][j].selLengthIndex || 0
            tempData.invoice_price = shoppingCartWithCoupons[i][j].invoice_price
            tempData.type = (i === 1 && 'addon') || (i === 2 && 'addon_addon')
            tempShoppingCart.push(tempData)
            tempTotal += calculateInvoicePrice(tempData)
          }
        }
      } else {
        if (Object.keys(shoppingCartWithCoupons[i]).length > 0) {
          let tempData = shoppingCartWithCoupons[i]

          const is_coupon = coupons.find((coupon) => coupon.plan_id === tempData.id)
          if (is_coupon) {
            tempData.card_name = tempData.card_name + ` ${is_coupon.coupon}`
            tempData.discount_flag = true
            tempData.discount = 0
            tempTotal -= 15
          }
          if (i === 0) tempData.type = 'base'
          else if (i === 2) tempData.type = 'affiliate'

          tempShoppingCart.push(tempData)

          tempTotal += calculateInvoicePrice(tempData)
        }
      }
    }
    console.log('Shopping Cart PaymentInfo - Final total calculation:', {
      tempTotal,
      finalTotal: tempTotal + 15,
    })
    setTotalPrice(tempTotal + 15)
    setCurShoppingCart(tempShoppingCart)
    getTermFlag()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coupons])
  useEffect(() => {
    if (state.countrieSettings) setCurCountries(state.countrieSettings)
    if (curUserInfo && curUserInfo.countryId) getAllowedPaymentMethod(curUserInfo.countryId || 0)
    if (state.currencies)
      setCurEuroRate(state.currencies.find((item: any) => item.currency_code === 'EUR')?.value || 1)
  }, [state.countrieSettings, state.paymentSettings, state.currencies])

  // Re-fetch the VAT estimate for the SELECTED BILLING COUNTRY whenever it changes — "Use my
  // info" vs. a separate billing address, or the chosen address itself (Task 4 fix round 1). The
  // shop-entry IP estimate (state.vatEstimate) stays as the fallback while no billing country is
  // known yet; see resolveDisplayVatRate in the summary render below. getVatEstimate never
  // throws, so a failed fetch just resolves to its own {rate: 0, ...} fallback — never a crash,
  // never a stale/wrong rate left on screen.
  useEffect(() => {
    let cancelled = false
    const billingCountryId = resolveBillingCountryId({
      curUserToBilling,
      curUserInfoCountryId: curUserInfo?.countryId,
      billingAddresses: curBillingAddress,
    })
    if (!billingCountryId) {
      setCurBillingVatEstimate(null)
      return
    }
    getVatEstimate(billingCountryId).then((estimate) => {
      if (!cancelled) setCurBillingVatEstimate(estimate)
    })
    return () => {
      cancelled = true
    }
  }, [curUserToBilling, curUserInfo?.countryId, curBillingAddress])

  const getAllowedPaymentMethod = async (countrySelId: number) => {
    const token = state.countrieSettings.find((item: any) => item.id === countrySelId) || {}
    setCurTrustStatus(true)
    setCurCountryCode(token.country_code)
    let paymentSetting = state.paymentSettings
    let statusFlag = false

    setPaymentMethodSettings({
      cardinity: token?.cardinity === 1 && paymentSetting?.cardinity_signup === 1,
      airwallex_eps: token?.airwallex === 1 && paymentSetting?.airwallex_eps_signup === 1,
      airwallex_giropay: token?.airwallex === 1 && paymentSetting?.airwallex_giropay_signup === 1,
      airwallex_applepay: token?.airwallex === 1 && paymentSetting?.airwallex_applepay_signup === 1,
      airwallex_googlepay:
        token?.airwallex === 1 && paymentSetting?.airwallex_googlepay_signup === 1,
      airwallex_cc: token?.airwallex === 1 && paymentSetting?.airwallex_cc_signup === 1,
      advcash: token?.advcash === 1 && paymentSetting?.advcash_signup === 1,
      bpay: token?.bpay === 1 && paymentSetting?.bpay_signup === 1,
      micropayment_prepay:
        token?.micropayment_banktransfer === 1 &&
        paymentSetting?.micropayment_banktransfer_signup === 1,
      micropayment_sofort:
        token?.micropayment_sofort === 1 && paymentSetting?.micropayment_sofort_signup === 1,
      reap_cc: token?.creditcard === 1 && paymentSetting?.reap_signup === 1,
      coinbase: token?.coinbase === 1 && paymentSetting?.coinbase_signup === 1,
      skrill_rapid: token?.skrill === 1 && paymentSetting?.skrill_signup_rapid === 1,
      skrill_cc: token?.skrill === 1 && paymentSetting?.skrill_signup_cc === 1,
      skrill_neteller: token?.skrill === 1 && paymentSetting?.skrill_signup_neteller === 1,
      skrill: token?.skrill === 1 && paymentSetting?.skrill_signup === 1,
    })
  }

  const getTermFlag = async () => {
    const resultData = await axios.post(
      `${BACKEND_API_URL}/getTermsflag`,
      {},
      {
        headers: {'x-access-token': `${DEFAULTTOKEN}`},
      }
    )
    const {token, result, auth} = resultData.data

    if (auth === false) {
      removeAllSession()
      history.push('/auth/login')
    } else if (result === 'success') {
      setCurEmailStatus(token[0]?.newletterflag === 1 ? true : false)
    }
  }
  const saveTermFlag = async () => {
    let termFlagReq = {
      newletterflag: curEmailStatus,
    }
    const resultData = await axios.post(`${BACKEND_API_URL}/saveTermsflag/`, termFlagReq, {
      headers: {'x-access-token': `${DEFAULTTOKEN}`},
    })
    let {auth} = resultData?.data
    if (auth === false) {
      removeAllSession()
      history.push('/auth/login')
    }
  }

  const handleCreateSub = async () => {
    let basePlan = {}
    let addonPlan: Array<any> = []
    let addon_addonPlan: Array<any> = []
    let affiliatePlan = {}
    let billingAddress = []
    let payment_method = ''
    setCurCreateSubLoading(true)

    for (let i = 0; i < curShoppingCart.length; i++) {
      if (curShoppingCart[i].type === 'base') basePlan = curShoppingCart[i]
      else if (curShoppingCart[i].type === 'affiliate') affiliatePlan = curShoppingCart[i]
      else if (curShoppingCart[i].type === 'addon') addonPlan.push(curShoppingCart[i])
      else if (curShoppingCart[i].type === 'addon_addon') addon_addonPlan.push(curShoppingCart[i])
    }
    curUserInfo.useStatus = curUserToBilling
    billingAddress = curBillingAddress

    let currency = 'USD'
    let paymentMethodVal = ''

    if (!paymentMethod) {
      setCurCreateSubLoading(false)
      swal({title: 'Error', text: 'Please select payment method', icon: 'error'})
      return
    }
    // Send payment method ID — backend handles provider routing
    paymentMethodVal = paymentMethod

    let statusUpload = true
    let uploadFileUrl = ''

    if (statusUpload === true) {
      const body = buildSignUpBody({
        shoppingCart: curShoppingCart,
        currency,
        paymentMethod: payment_method,
        paymentMethodVal,
        coupons,
        curUserInfo,
        sponsorId,
        billingAddress,
        curTermsStatus,
        curDisclaimerStatus,
        curEmailStatus,
      })
      const response = await fetch(`${BACKEND_API_V2}/webshop/user/sign_up`, {
        method: 'POST',
        body: JSON.stringify(body),
      })
        .then((res) => {
          return res.json()
        })
        .catch((err) => {
          console.error(err)
          setCurCreateSubLoading(false)
          swal({
            title: 'Error',
            text: 'Something went wrong. Please try again.',
            icon: 'error',
          })
        })
      if (!response) {
        setCurCreateSubLoading(false)
        return
      }
      if (response.status === 'error') {
        setCurCreateSubLoading(false)

        swal({
          title: `Error`,
          text: `${response.message}`,
          icon: 'error',
        })
        return
      }
      if (!response) {
        setCurCreateSubLoading(false)
        swal({
          title: `Internal Server Error`,
          text: `Please Try again`,
          icon: 'error',
        })
        return
      }
      // Establish the session token. Under SSO with a Keycloak token from signup, prefer it (KC owns
      // the credential); otherwise the legacy jwt. Stored to localStorage('token') — the key the axios
      // interceptor and ~400 reads use — so the member is authenticated for API calls immediately AND
      // when they return from the payment provider.
      //
      // NOTE: a raw KC token from signup is NOT an oidc-client-ts session. It survives in-app (SPA)
      // navigation but not a FULL RELOAD, and AuthInit is OIDC-session-driven — so a checkout signup,
      // which leaves for an external payment provider and reloads on return, will pass through the KC
      // login once. The KC account exists (created at signup) so that login succeeds; making the paid
      // return fully form-less needs a separate AuthInit change to accept a stored token as a session.
      const usingKc = SSO_ENABLED && !!response.kc?.access_token
      const sessionToken = usingKc ? response.kc.access_token : response.jwt
      if (sessionToken) {
        localStorage.setItem('token', sessionToken)
        localStorage.setItem('security_flag', '0')
        localStorage.setItem('confirm_flag', '1')
        localStorage.setItem('restriction_flag', '0')
      }

      const redirectUrl =
        response?.webshop?.createPayment?.paymentResponse?.redirect_url ??
        response?.redirect_url
      if (redirectUrl) {
        // Paid signup: proceed to the payment provider. The stored token authenticates the return.
        // Push confirmation page into history so browser-back lands there instead of checkout.
        const invoiceName = response?.webshop?.createPayment?.invoice_name || response?.invoice_name || ''
        if (invoiceName) {
          window.history.pushState(null, '', `/order/confirmation?invoiceId=${invoiceName}`)
        }
        window.location.href = redirectUrl
      } else if (usingKc) {
        // Free signup under SSO (no payment step): auto-login into the SPA with NO reload and NO KC
        // login page — set the redux session from the KC token (empty profile, like AuthInit's
        // fallback) and land on the dashboard.
        dispatch(
          auth.actions.login(0, sessionToken, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '')
        )
        history.push('/dashboard')
      } else {
        swal({title: 'Error', text: 'No redirect URL received from payment provider', icon: 'error'})
        setCurCreateSubLoading(false)
      }
    }
  }

  // Billing Address
  const handleAddressAdd = () => {
    setCurCompanyname('')
    setCurFirstName('')
    setCurLastName('')
    setCurStreet('')
    setCurSuite('')
    setCurZipcode('')
    setCurCity('')
    setCurCountry('')
    setCurCountryId(0)

    setBackStyle('modal-backdrop show ')
    setAddAddressStyle('modal show billing-address-modal-show')
  }
  const handleAddressModalClose = () => {
    setBackStyle('')
    setAddAddressStyle('modal')
  }
  // Single billing-address entry: creating or editing always replaces the one entry and marks it
  // as the active one (useStatus: true) — there is no longer a second entry to select between, so
  // the extra "select this address" click the multi-address flow required is no longer needed.
  const handleBillingAddress = () => {
    const billingAddress = {
      index: 0,
      useStatus: true,
      companyname: curCompanyname,
      firstname: curFirstName,
      secondname: curLastName,
      streetaddress: curStreet,
      suite: curSuite,
      postalcode: curZipcode,
      cityaddress: curCity,
      country: curCountry,
      countryId: curCountryId,
    }

    setCurUserToBilling(false)
    setContainBilling(true)
    setCurBillingAddress([billingAddress])
    getAllowedPaymentMethod(curCountryId)

    setBackStyle('')
    setAddAddressStyle('modal')
  }
  const handleBillingEdit = (index: number) => {
    setCurCompanyname(curBillingAddress[index]?.companyname)
    setCurFirstName(curBillingAddress[index]?.firstname)
    setCurLastName(curBillingAddress[index]?.secondname)
    setCurStreet(curBillingAddress[index]?.streetaddress)
    setCurSuite(curBillingAddress[index]?.suite)
    setCurZipcode(curBillingAddress[index]?.postalcode)
    setCurCity(curBillingAddress[index]?.cityaddress)
    setCurCountry(curBillingAddress[index]?.country)
    setCurCountryId(curBillingAddress[index]?.countryId)

    let status = false
    for (let i = 0; i < curCountries.length; i++) {
      if (curCountries[i]?.id === curBillingAddress[index].countryId) {
        status = true
        break
      }
    }
    if (status === false && curCountries.length > 0) {
      setUnCheckedCountry(curBillingAddress[index].country)
      setUnCheckedCountryId(curBillingAddress[index].countryId)
    }

    setBackStyle('modal-backdrop show ')
    setAddAddressStyle('modal show billing-address-modal-show')
  }
  const handleUseAddress = (index: number, checkedStatus: boolean) => {
    const {
      addresses,
      containBilling: nextContainBilling,
      selectedAddress,
    } = computeBillingAddressSelection(curBillingAddress, index, checkedStatus)

    // Nothing selected afterwards (e.g. deselecting the sole address) → fall back to billing via
    // account info, same as the default state, instead of crashing on a missing selection.
    setCurUserToBilling(!selectedAddress)

    if (selectedAddress) {
      getAllowedPaymentMethod(selectedAddress.countryId)
    } else if (curUserInfo && curUserInfo.countryId) {
      getAllowedPaymentMethod(curUserInfo.countryId)
    }

    setContainBilling(nextContainBilling)
    setCurBillingAddress(addresses)
  }
  const handleUserToBilling = (checked: boolean) => {
    setCurUserToBilling(checked)

    let tempTotalBilling: Array<any> = []

    if (checked === true) {
      for (let i = 0; i < curBillingAddress?.length; i++) {
        let tempBillingAddress = {
          index: curBillingAddress[i]?.index,
          useStatus: false,
          companyname: curBillingAddress[i]?.companyname,
          firstname: curBillingAddress[i]?.firstname,
          secondname: curBillingAddress[i]?.secondname,
          streetaddress: curBillingAddress[i]?.streetaddress,
          suite: curBillingAddress[i]?.suite,
          postalcode: curBillingAddress[i]?.postalcode,
          cityaddress: curBillingAddress[i]?.cityaddress,
          country: curBillingAddress[i]?.country,
          countryId: curBillingAddress[i]?.countryId,
        }

        tempTotalBilling.push(tempBillingAddress)
      }

      // Refresh payment methods for the user's own country
      getAllowedPaymentMethod(curUserInfo?.countryId || 0)
      setContainBilling(false)
      setCurBillingAddress(tempTotalBilling)
    }
  }

  const handleChangeCountry = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newCountryId = parseInt(e.target.selectedOptions[0].value)
    setCurCountry(e.target.selectedOptions[0].text)
    setCurCountryId(newCountryId)
    getAllowedPaymentMethod(newCountryId)
  }

  return (
    <>
      <div id='widget'></div>
      <div className='container-xxl pb-5 pt-2 px-2 px-md-3 px-lg-5'>
        <div className='d-flex flex-column flex-lg-row' style={{gap: '10px'}}>
          <div className='flex-lg-row-fluid order-1 order-lg-1 mb-10 mb-lg-0 d-flex flex-column'>
            {/* Billing Address */}
            <div className='card shadow-sm mt-5 mb-5 mb-xl-10'>
              <div className='card-header'>
                <div className='card-title'>
                  <h3>{t('ACCOUNT_BILLING_ADDRESS_TITLE')}</h3>
                </div>
              </div>
              <div className='card-body'>
                <div className='row gx-9 gy-6'>
                  {curUserInfo && (curUserInfo.firstname || curUserInfo.username) && (
                    <div className='col-xxl-6'>
                      <div
                        className={`card card-dashed flex-row flex-stack flex-wrap p-4 h-100 ${curUserToBilling ? 'border border-primary border-2' : ''}`}
                        style={{cursor: 'pointer'}}
                        onClick={() => handleUserToBilling(!curUserToBilling)}
                      >
                        <div className='d-flex flex-column flex-grow-1'>
                          <div className='d-flex align-items-center justify-content-between mb-2'>
                            <div className='fs-5 fw-bolder'>{curUserInfo?.username || ''}</div>
                          </div>
                          <div className='fs-6 fw-bold text-gray-600 mb-2'>
                            {curUserInfo?.firstname}&nbsp;&nbsp;{curUserInfo?.secondname}
                            <br />
                            {curUserInfo?.suite}&nbsp;&nbsp;{curUserInfo?.streetaddress}
                            <br />
                            {curUserInfo?.postalcode}&nbsp;&nbsp;{curUserInfo?.cityaddress}
                            <br />
                            {getCountryDisplayName(curUserInfo?.countryId)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {curBillingAddress.length > 0 ? (
                    <div className='col-xxl-6'>
                      <div
                        className={`card card-dashed flex-row flex-stack flex-wrap p-4 h-100 ${curBillingAddress[0]?.useStatus ? 'border border-primary border-2' : ''}`}
                        style={{cursor: 'pointer'}}
                        onClick={() => handleUseAddress(0, !curBillingAddress[0]?.useStatus)}
                      >
                        <div className='d-flex flex-column flex-grow-1'>
                          <div className='d-flex align-items-center justify-content-between mb-2'>
                            <div className='fs-5 fw-bolder'>
                              {curBillingAddress[0]?.companyname}
                            </div>
                          </div>
                          <div className='fs-6 fw-bold text-gray-600 mb-2'>
                            {curBillingAddress[0]?.firstname}&nbsp;&nbsp;
                            {curBillingAddress[0]?.secondname}
                            <br />
                            {curBillingAddress[0]?.suite}&nbsp;&nbsp;
                            {curBillingAddress[0]?.streetaddress}
                            <br />
                            {curBillingAddress[0]?.postalcode}&nbsp;&nbsp;
                            {curBillingAddress[0]?.cityaddress}
                            <br />
                            {curBillingAddress[0]?.country}
                          </div>
                          <div className='d-flex align-items-center gap-2'>
                            <button
                              className='btn btn-sm btn-light btn-active-light-primary'
                              onClick={(e) => {
                                e.stopPropagation()
                                handleBillingEdit(0)
                              }}
                            >
                              {t('BTN_TEXT_EDIT')}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className='col-xxl-6'>
                      <div
                        className='notice d-flex bg-light rounded border-gray-300 border border-dashed flex-stack p-4 h-100'
                        style={{cursor: 'pointer'}}
                        onClick={handleAddressAdd}
                      >
                        <div className='d-flex flex-column flex-grow-1'>
                          <h4 className='text-gray-900 fw-bolder mb-2'>
                            {t('PERSONAL_SUBSCRIPTION_CUSTOM_DLG_RENEW_ALERT_TITLE1')}
                          </h4>
                          <div className='fs-6 text-gray-700'>
                            {t('PERSONAL_SUBSCRIPTION_CUSTOM_DLG_RENEW_ALERT_CONTENT1')}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Payment methods */}
            <div className='card shadow-sm pt-3 mb-5 mb-lg-10'>
              <div className='card-header'>
                <div className='card-title'>
                  <h2 className='fw-bolder'>{t('PERSONAL_SUBSCRIPTION_CUSTOM_SUBTITLE1_9')}</h2>
                </div>
              </div>
              <div className='card-body pt-0'>
                <PaymentMethodSelector
                  countryId={curUserInfo?.countryId}
                  amountEur={totalPrice * curEuroRate}
                  selectedMethod={paymentMethod}
                  onMethodChange={setPaymentMethod}
                  walletMode='hidden'
                />
              </div>
            </div>
            {/* Products */}
            <div className='card shadow-sm card-flush pt-3 mb-5 mb-lg-10'>
              <div className='card-header'>
                <div className='card-title'>
                  <h2 className='fw-bolder'>{t('SIDBAR_PRODUCTS_TITLE')}</h2>
                </div>
              </div>
              <div className='card-body pt-0'>
                <div className='table-responsive'>
                  <table
                    className='table align-middle table-row-dashed fs-6 fw-bold gy-4'
                    id='kt_subscription_products_table'
                  >
                    <thead>
                      <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                        <th className='min-w-300px'>{t('TEXT_PRODUCT')}</th>
                        <th className='min-w-100px'>{t('TEXT_PERIOD')}</th>
                        <th className='min-w-150px'>{t('TEXT_TOTALPRICE')}</th>
                        {/* <th className='min-w-70px text-end'>Remove&nbsp;</th> */}
                      </tr>
                    </thead>
                    <tbody className='text-gray-600'>
                      {curShoppingCart.map((item, key) => (
                        <tr key={key}>
                          <td>{item?.card_name}</td>
                          <td>
                            {item?.subscription_length === 0
                              ? 'Lifetime'
                              : (item?.selLengthIndex as number) > 23 && item?.type === 'addon'
                                ? 24 + ` ${t('TEXT_MONTHS')}`
                                : item?.type === 'addon'
                                  ? parseInt(item?.selLengthIndex) + 1 + ` ${t('TEXT_MONTHS')}`
                                  : item?.subscription_length + ` ${t('TEXT_MONTHS')}`}
                          </td>
                          <td>{'$' + (getInvoicePrice(item) || 0).toFixed(2)}</td>
                          {/* <td className='text-center cursor-pointer'>
                              <span
                                className='svg-icon svg-icon-1'
                                onClick={() => handleDelProduct(key)}
                              >
                                <KTSVG path='/media/icons/duotune/general/gen027.svg' />
                              </span>
                            </td> */}
                        </tr>
                      ))}
                      {curShoppingCart?.length > 0 && (
                        <tr>
                          <td>{t('TEXT_SIGNUP_FEE')}</td>
                          <td>{t('TEXT_ONE_TIME')}</td>
                          <td>$15</td>
                        </tr>
                      )}
                      {hasBasicPlanGift && (
                        <tr>
                          <td>{t('TEXT_SIGNUP_FEE')} waver</td>
                          <td>{t('TEXT_ONE_TIME')}</td>
                          <td>-$15</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <CouponComponent coupons={coupons} setCoupons={setCoupons} sign_up />
                </div>
              </div>
            </div>
          </div>
          {/* Summary */}
          <div className='flex-column flex-lg-row-auto w-100 w-lg-450px w-xl-550px order-2 order-lg-2'>
            <div className='card card-flush shadow-sm pt-5 mb-0 pb-5'>
              <div className='card-header'>
                <div className='card-title'>
                  <h2>{t('PERSONAL_SUBSCRIPTION_CUSTOM_TITLE2')}</h2>
                </div>
              </div>
              <div className='card-body pt-0 fs-6'>
                <div className='mb-7'>
                  <h5 className='mb-3'>{t('ACCOUNT_BILLING_ADDRESS_TITLE')}</h5>
                  {(() => {
                    const selectedAddress = curBillingAddress.find(
                      (item: any) => item.useStatus === true
                    )
                    if (curUserToBilling && curUserInfo) {
                      return (
                        <div className='mb-0'>
                          <div className='fw-bold text-gray-600'>
                            {curUserInfo?.username && (
                              <div className='mb-1'>{curUserInfo.username}</div>
                            )}
                            <div className='mb-1'>
                              {curUserInfo?.firstname} {curUserInfo?.secondname}
                            </div>
                            <div className='mb-1'>
                              {curUserInfo?.suite} {curUserInfo?.streetaddress}
                            </div>
                            <div className='mb-1'>
                              {curUserInfo?.postalcode} {curUserInfo?.cityaddress}
                            </div>
                            <div>{getCountryDisplayName(curUserInfo?.countryId)}</div>
                          </div>
                        </div>
                      )
                    } else if (selectedAddress) {
                      return (
                        <div className='mb-0'>
                          <div className='fw-bold text-gray-600'>
                            {selectedAddress.companyname && (
                              <div className='mb-1'>{selectedAddress.companyname}</div>
                            )}
                            <div className='mb-1'>
                              {selectedAddress.firstname} {selectedAddress.secondname}
                            </div>
                            <div className='mb-1'>
                              {selectedAddress.suite} {selectedAddress.streetaddress}
                            </div>
                            <div className='mb-1'>
                              {selectedAddress.postalcode} {selectedAddress.cityaddress}
                            </div>
                            <div>{getCountryDisplayName(selectedAddress.countryId)}</div>
                          </div>
                        </div>
                      )
                    } else {
                      return (
                        <div className='mb-0'>
                          <div className='fw-bold text-gray-600 text-muted'>
                            {t('TEXT_PLEASE_SELECT_INVOICE_ADDRESS') ||
                              'Please select an invoice address'}
                          </div>
                        </div>
                      )
                    }
                  })()}
                </div>
                <div className='separator separator-dashed mb-7'></div>
                <div className='mb-10'>
                  <h5 className='mb-3'>{t('TEXT_PAYMENT_DETAILS')}</h5>
                  {(() => {
                    // DISPLAY-only estimate — the backend recomputes VAT/reverse-charge
                    // authoritatively at signup (see signUpBody.ts, which never sends a vat
                    // amount). Integer-cents throughout via vatMoney, never totalPrice * rate.
                    //
                    // The rate comes from the SELECTED BILLING COUNTRY (curBillingVatEstimate,
                    // fetched per-country above) whenever one is known, falling back to the
                    // shop-entry IP estimate (state.vatEstimate, Task 2) only until it is —
                    // review fix: using the IP estimate unconditionally showed the wrong rate
                    // whenever the billing country differed from where the member's IP resolved.
                    const subtotalCents = toCents(totalPrice)
                    const billingCountryId = resolveBillingCountryId({
                      curUserToBilling,
                      curUserInfoCountryId: curUserInfo?.countryId,
                      billingAddresses: curBillingAddress,
                    })
                    const rate = resolveDisplayVatRate({
                      billingCountryId,
                      billingEstimate: curBillingVatEstimate,
                      ipEstimate: state?.vatEstimate,
                    })
                    // Single VAT switch (backend vat_active: flag + go-live date). Off → no VAT math
                    // and no VAT lines, so checkout looks exactly as it did pre-VAT.
                    const vatActive =
                      (curBillingVatEstimate ?? state?.vatEstimate)?.vat_active === true
                    const vatSummary = checkoutVatSummary({
                      subtotalCents,
                      rate: vatActive ? rate : 0,
                      memberType: curUserInfo?.memberType,
                      vatStatus: curUserInfo?.vatStatus,
                    })
                    const totalAmount = fromCents(vatSummary.totalCents)
                    const formatUsd = (value: number) =>
                      new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                      }).format(value)

                    return (
                      <div className='mb-0'>
                        {vatActive && (
                          <>
                            <div className='mb-2'>
                              <span className='fw-bold text-gray-600'>
                                {t('TEXT_SUBTOTAL')}: {formatUsd(totalPrice)}
                              </span>
                            </div>
                            <div className='mb-2'>
                              <span className='fw-bold text-gray-600'>
                                {vatSummary.reverseCharge
                                  ? t('TEXT_REVERSE_CHARGE')
                                  : t('TEXT_VAT', {rate})}
                                : {formatUsd(fromCents(vatSummary.vatCents))}
                              </span>
                            </div>
                            {vatSummary.reverseCharge && (
                              <div className='mb-2'>
                                <div className='text-muted fs-8'>
                                  {t('TEXT_REVERSE_CHARGE_NOTE')}
                                </div>
                                {curUserInfo?.vat_id && (
                                  <div className='text-gray-600'>
                                    {t('TEXT_BUYER_VAT_ID')}: {curUserInfo.vat_id}
                                  </div>
                                )}
                              </div>
                            )}
                          </>
                        )}
                        <div className='mb-2'>
                          <span className='fw-bold text-gray-600'>
                            {t('TEXT_TOTAL')}: {formatUsd(totalAmount)}
                          </span>
                        </div>
                        {!paymentMethod && (
                          <div className='mb-2'>
                            <span className='fw-bold text-gray-600 text-muted'>
                              {t('TEXT_PLEASE_SELECT_PAYMENT_METHOD') ||
                                'Please select a payment method'}
                            </span>
                          </div>
                        )}
                      </div>
                    )
                  })()}
                </div>
                <div className='separator separator-dashed mb-7'></div>
                <div className='mb-10'>
                  <h5 className='mb-3'>{t('TEXT_LEGALTERM_TITLE')}</h5>
                  <div className='mb-0'>
                    <div className='form-check form-check-custom form-check-solid align-items-start mb-2'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        style={{border: '1px solid #0e0e122e'}}
                        checked={curTermsStatus}
                        onChange={(e) => setCurTermsStatus(e.target.checked)}
                      />
                      <label
                        className='form-check-label'
                        dangerouslySetInnerHTML={{__html: t('TEXT_LEGALTERM_CONTENT1')}}
                      />
                    </div>
                    <div className='form-check form-check-custom form-check-solid align-items-start mb-2'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        style={{border: '1px solid #0e0e122e'}}
                        checked={curDisclaimerStatus}
                        onChange={(e) => setCurDisclaimerStatus(e.target.checked)}
                      />
                      <label
                        className='form-check-label'
                        dangerouslySetInnerHTML={{__html: t('TEXT_LEGALTERM_CONTENT2')}}
                      />
                    </div>
                    <div className='form-check form-check-custom form-check-solid align-items-start mb-2'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        style={{border: '1px solid #0e0e122e'}}
                        checked={curEmailStatus}
                        onChange={(e) => setCurEmailStatus(e.target.checked)}
                      />
                      <label
                        className='form-check-label'
                        dangerouslySetInnerHTML={{__html: t('TEXT_LEGALTERM_CONTENT3')}}
                      />
                    </div>
                  </div>
                </div>
                <div className='mb-0'>
                  <button
                    type='submit'
                    className='btn btn-primary'
                    id='kt_subscriptions_create_button'
                    disabled={
                      curTermsStatus === false ||
                      curDisclaimerStatus === false ||
                      (containBilling === false && curUserToBilling === false) ||
                      curCreateSubLoading === true ||
                      !paymentMethod
                    }
                    onClick={handleCreateSub}
                  >
                    {curCreateSubLoading === true ? (
                      <span className='indicator-label'>{t('TEXT_PLEASEWAIT')}</span>
                    ) : (
                      <span className='indicator-label'>{t('TEXT_CREATE_SUBSCRIPTION')}</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Billing Address */}
      <div className={addAddoressStyle} tabIndex={-1} id='kt_modal_new_address' aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <div className='modal-content'>
            <div className='modal-header' id='kt_modal_new_address_header'>
              <h2>{t('ACCOUNT_BILLING_ADDRESS_TITLE')}</h2>
              <div
                className='btn btn-sm btn-icon btn-active-color-primary'
                data-bs-dismiss='modal'
                onClick={handleAddressModalClose}
              >
                <span className='svg-icon svg-icon-1'>
                  <KTSVG path='/media/icons/duotune/general/gen040.svg' />
                </span>
              </div>
            </div>
            <div className='modal-body py-10 px-lg-17'>
              <div
                className='scroll-y me-n7 pe-7'
                id='kt_modal_new_address_scroll'
                data-kt-scroll='true'
                data-kt-scroll-activate='{default: false, lg: true}'
                data-kt-scroll-max-height='auto'
                data-kt-scroll-dependencies='#kt_modal_new_address_header'
                data-kt-scroll-wrappers='#kt_modal_new_address_scroll'
                data-kt-scroll-offset='300px'
              >
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_BILLING_ADDRESS_DLG_COMPANYNAME')}
                  </label>
                  <input
                    type='text'
                    name='company name'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_BILLING_ADDRESS_DLG_COMPANYNAME')}
                    value={curCompanyname}
                    onChange={(e) => setCurCompanyname(e.target.value)}
                  />
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_OVERVIEW_DESC_FIRSTNAME')}
                  </label>
                  <input
                    type='text'
                    name='First name'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_OVERVIEW_DESC_FIRSTNAME')}
                    value={curFirstName}
                    onChange={(e) => setCurFirstName(e.target.value)}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement
                      setCurFirstName(target.value)
                    }}
                  />
                  {curFirstName.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_OVERVIEW_DESC_FIRSTNAME_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_BILLING_ADDRESS_DLG_LASTNAME')}
                  </label>
                  <input
                    type='text'
                    name='Last name'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_BILLING_ADDRESS_DLG_LASTNAME')}
                    value={curLastName}
                    onChange={(e) => setCurLastName(e.target.value)}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement
                      setCurLastName(target.value)
                    }}
                  />
                  {curLastName.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_BILLING_ADDRESS_DLG_LASTNAME_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_OVERVIEW_DESC_STREET')}
                  </label>
                  <input
                    type='text'
                    name='street'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_OVERVIEW_DESC_STREET')}
                    value={curStreet}
                    onChange={(e) => setCurStreet(e.target.value)}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement
                      setCurStreet(target.value)
                    }}
                  />
                  {curStreet.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_OVERVIEW_DESC_STREET_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_BILLING_ADDRESS_DLG_SUITE1')}
                  </label>
                  <input
                    type='text'
                    name='suite'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_BILLING_ADDRESS_DLG_SUITE2')}
                    value={curSuite}
                    onChange={(e) => setCurSuite(e.target.value)}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement
                      setCurSuite(target.value)
                    }}
                  />
                  {curSuite.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_BILLING_ADDRESS_DLG_SUITE_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_OVERVIEW_DESC_ZIPCODE')}
                  </label>
                  <input
                    type='text'
                    name='postalcode'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_OVERVIEW_DESC_ZIPCODE')}
                    value={curZipcode}
                    onChange={(e) => setCurZipcode(e.target.value)}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement
                      setCurZipcode(target.value)
                    }}
                  />
                  {curZipcode.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_OVERVIEW_DESC_ZIPCODE_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_OVERVIEW_DESC_CITY')}
                  </label>
                  <input
                    type='text'
                    name='cityaddress'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_OVERVIEW_DESC_CITY')}
                    value={curCity}
                    onChange={(e) => setCurCity(e.target.value)}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement
                      setCurCity(target.value)
                    }}
                  />
                  {curCity.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_OVERVIEW_DESC_CITY_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_OVERVIEW_DESC_COUNTRY')}
                  </label>
                  <select
                    className='form-select form-select-lg form-select-solid'
                    data-control='select2'
                    data-placeholder='Select Country...'
                    value={curCountryId}
                    onChange={handleChangeCountry}
                    style={{
                      color:
                        unCheckedCountry.length > 0 && curCountryId === unCheckedCountryId
                          ? 'red'
                          : 'black',
                      fontSize: '16px', // Prevent zoom on iOS and ensure readable size on mobile
                    }}
                  >
                    {localizedCountries.map((item, i) => (
                      <option value={item?.id} key={i} style={{color: 'black'}}>
                        {item.display_name}
                      </option>
                    ))}
                    {unCheckedCountry.length > 0 && (
                      <option value={unCheckedCountryId} style={{color: 'red'}}>
                        {getCountryDisplayName(unCheckedCountryId)}
                      </option>
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className='modal-footer flex-center'>
              <button className='btn btn-light me-3' onClick={handleAddressModalClose}>
                {t('BTN_TEXT_DISCARD')}
              </button>
              <button
                className='btn btn-primary'
                disabled={
                  curFirstName.length === 0 ||
                  curLastName.length === 0 ||
                  curStreet.length === 0 ||
                  curSuite.length === 0 ||
                  curZipcode.length === 0 ||
                  curCity.length === 0
                }
                onClick={handleBillingAddress}
              >
                <span className='indicator-label'>{t('BTN_TEXT_CONFIRM')}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  shoppingCart: state.webshop.shoppingCart,
  curUserInfo: state.webshop.curUserInfo,
  sponserUserName: state.webshop.sponserUserName,
  sponsorId: state.webshop.sponsorId,
  sponsorFirstName: state.webshop.sponsorFirstName,
  sponsorSecondName: state.webshop.sponsorSecondName,
  globalMasteryDiscount: state.webshop.globalMasteryDiscount,
})

export default connect(mapStateToProps, {})(PaymentInfo)
